<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showModalEtapas"
    no-close-on-backdrop
    size="md"
    scrollable
    title="Configuración Etapas"
    cancel-variant="outline-secondary"
  >
    <div
      style=" width:100%; text-align: right;
    font-size: 10px;
    font-weight: bold"
    >
      Campeonato Actual: {{ idCampeonato }}
    </div>
    <div style="display:flex">
      <h2>Etapas</h2>

      <b-button
        v-if="USER().rol == ROLES.SUPER"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        class="btn-icon ml-1"
        style="margin-top:-8px"
        size="sm"
        @click="addEtapa"
      >
        <feather-icon size="22" icon="PlusCircleIcon" />
      </b-button>
    </div>
    <b-tabs v-model="tabIndex">
      <b-tab
        v-for="item in listEtapas"
        :key="item.id_modalidad"
        :title="`Etapa ${item.etapa}`"
      >
        <item-etapa :dataEtapa="item"></item-etapa>
      </b-tab>
    </b-tabs>
    <b-button
      v-if="USER().rol == ROLES.SUPER"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="secondary"
      size="sm"
      class="float-left mt-2"
      @click="resetPosSorteo"
    >
      Reset Pos Sorteo: {{ total }}
    </b-button>
    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-if="USER().rol == ROLES.SUPER"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="saveModalidad"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cerrar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
// import store from '@/store'
import Ripple from 'vue-ripple-directive'

import {
  BModal,
  // BRow,
  // BCol,
  // BFormInput,
  BTab,
  BTabs,
  BButton,
  BSpinner,
  // xx
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import itemEtapa from './ItemEtapa.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  // xx
} from '../../utils/variables'
// import vSelect from 'vue-select'

export default {
  components: {
    BModal,
    // BRow,
    // BCol,
    // BFormInput,
    // vSelect,
    BTab,
    BTabs,
    itemEtapa,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    listEtapas: Array,
    idCategoria: String,
    idCampeonato: String,
    total: Number,
  },
  setup(props, { emit }) {
    // const categoriaAdmin = ref(null)
    // const apodo = ref('')
    const { postApi } = apiCall()
    const showLoading = ref(false)
    const etapaSeleccionada = ref(null)
    const tabIndex = ref(null)
    watch(tabIndex, despues => {
      etapaSeleccionada.value = props.listEtapas[despues]
    })
    function addEtapa() {
      const etapa = {
        id_modalidad: null,
        etapa: props.listEtapas.length + 1,
        grupos: [],
        estado: 'a',
      }
      props.listEtapas.push(etapa)
    }
    function setEtapaSeleccionada(item) {
      etapaSeleccionada.value = item
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_MODAL_ETAPAS', false)
    }

    async function resetPosSorteo() {
      showLoading.value = true
      const path = 'ApiFixture/resetSorteo'
      const data = {
        id_categoria: props.idCategoria,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        emit('getModalidad', data.id_categoria)
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ACTUALIZADO con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          }
        )
        // console.log(response)
      }
      showLoading.value = false

      // console.log(etapaSeleccionada.value)
    }
    async function saveModalidad() {
      showLoading.value = true
      const path = 'ApiConfiguration/insertUpdateModalidad'
      const data = {
        id_modalidad: etapaSeleccionada.value.id_modalidad,
        id_categoria: props.idCategoria,
        etapa: etapaSeleccionada.value.etapa,
        estado: etapaSeleccionada.value.estado,
        grupos: etapaSeleccionada.value.grupos,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      if (data.grupos.length === 0) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Debes crear por lo menos un grupo',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          }
        )
      } else {
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          emit('getModalidad', data.id_categoria)
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'ACTUALIZADO con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            }
          )
          // console.log(response)
        }
      }
      showLoading.value = false

      // console.log(etapaSeleccionada.value)
    }

    return {
      addEtapa,
      saveModalidad,
      setEtapaSeleccionada,
      etapaSeleccionada,
      USER,
      ROLES,
      showLoading,
      onlyClose,
      tabIndex,
      resetPosSorteo,
    }
  },
}
</script>
<style lang="scss"></style>
